import { render, staticRenderFns } from "./membercardDashboard.vue?vue&type=template&id=06492364"
import script from "./membercardDashboard.vue?vue&type=script&lang=js"
export * from "./membercardDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports